import type { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import type { SelectMetadata } from 'src/data-capture/types';
import type { BaseFinancialItem, PensionAsset } from './hooks/useFinancialItems';

function isPensionAsset(item: BaseFinancialItem): item is PensionAsset {
  return 'pensionProduct' in item;
}

export function getFinancialItemEntityType(item: BaseFinancialItem): string {
  return isPensionAsset(item) ? item.pensionProduct : item.product;
}

export function getFinancialItemType(
  item: BaseFinancialItem,
  metadata: DynamicUiEntitiesMetadata,
): string | undefined {
  const typeMetadata = metadata[getFinancialItemEntityType(item)]?.type;
  return (typeMetadata as SelectMetadata).options.find(option => option.value === item.type)?.label;
}
